import { daysFormat } from '@/filters'
import {
  setCheckButtons,
  setTableButtons,
  setFormButtons
} from '@/utils/getbuttons.js'
import {
  isTzInspectionOrg,
  TZ_INSPECTION_ORG_NAME
} from '@/utils/bidLevelActions.js'
import { isFixedEquipmentParamKey } from '@/utils/equipmentParams.js'

function pickOrgVal(...vals) {
  for (let i = 0; i < vals.length; i++) {
    const val = vals[i]
    if (val !== undefined && val !== null && String(val).trim() !== '') {
      return String(val).trim()
    }
  }
  return ''
}

function currentCompany(params) {
  return (
    (params.state &&
      params.state.enterprise &&
      params.state.enterprise.enterpriseBaseInfo) ||
    {}
  )
}

function ownerNameOf(params) {
  const info = currentCompany(params)
  const org =
    (params.getters &&
      (params.getters['user/organization'] || params.getters.organization)) ||
    {}
  return pickOrgVal(
    info.orgName,
    info.name,
    org.orgCode,
    org.orgName,
    params.orgName
  )
}

function ownerCardOf(params) {
  const info = currentCompany(params)
  return pickOrgVal(info.creditCode, info.creditcode)
}

function ownerPhoneOf(params) {
  const info = currentCompany(params)
  return pickOrgVal(
    info.contactTel,
    info.contacttel,
    info.legalPersonTel,
    info.legalpersontel
  )
}

const ownEquipment = {
  ownEquipment: {
    name: 'ownEquipment',
    componentTypes: [
      'navigate',
      'check',
      'tables',
      'stepForm',
      'drawerTable',
      'dialogForm'
    ],
    addFun: 'officialCar/addOfficialCar',
    editFun: 'officialCar/editOfficialCar',
    getListFun: 'officialCar/getCarsList',
    deleteFun: 'officialCar/deleteOfficialCar',
    detailPage: [
      {
        buttonName: '新增',
        name: 'ownEquipment',
        type: 'stepForm',
        theme: 'ownEquipment',
        step: 'ownEquipmentInfo',
        label: '新增自有机械',
        checkFun: 'officialCar/getOwnEquipmentAddForm'
      },
      {
        buttonName: '编辑',
        name: 'ownEquipment',
        type: 'stepForm',
        theme: 'ownEquipment',
        step: 'ownEquipmentInfo',
        label: '编辑自有机械',
        checkType: 'checkByUid',
        checkFun: 'officialCar/getOfficialCarInfo'
      },
      {
        buttonName: '设备参数',
        name: 'paramJson',
        type: 'dialogForm',
        checkType: 'checkByUid',
        checkFun: 'officialCar/getOfficialCarInfo',
        pageStatus: 'edit'
      },
      {
        buttonName: '保险到期日期',
        name: 'insurance',
        type: 'drawerTable',
        checkType: 'checkByUid',
        checkFun: 'officialCar/getOfficialCarInfo'
      },
      {
        buttonName: '最近保养日期',
        name: 'maintenance',
        type: 'drawerTable',
        checkType: 'checkByUid',
        checkFun: 'officialCar/getOfficialCarInfo'
      }
    ],
    headButtons: setCheckButtons(['新增']),
    queryParams: {
      query: '',
      ownerName: (params) => ownerNameOf(params),
      limit: '',
      page: ''
    },
    selectData: [
      {
        key: 'query',
        label: '关键字',
        type: 'input',
        placeholder: '设备名称/设备编号/所有人'
      }
    ],
    tagInfo: '仅显示所有人为当前企业的施工机械。新增时默认所有人为本企业，保险、保养和设备参数直接维护在施工机械库。',
    outListHeight: 210,
    rowData: (params) => {
      return params.state.officialCar.carsList.result
    },
    rowTotal: (params) => {
      return params.state.officialCar.carsList.totalSize
    },
    columns: (params) => {
      return [
        {
          prop: 'carCode',
          label: '设备编号'
        },
        {
          prop: 'carName',
          label: '设备名称'
        },
        {
          prop: 'carModel',
          label: '设备型号'
        },
        {
          prop: 'ownerName',
          label: '所有人',
          tooltip: () => {
            return (row) => {
              return { tipValue: row.ownerName + '\xa0\xa0' + (row.ownerCardNum || '') }
            }
          }
        },
        {
          prop: 'ownerPhone',
          label: '所有人联系电话'
        },
        {
          prop: 'paramJsonInfo',
          label: '设备参数',
          drillDown: true,
          tooltip: { tipValue: '点击修改添加参数指标' }
        },
        {
          prop: 'isExpired',
          label: '保险状态',
          width: '80px',
          tag: params.dictionarys.isExpired
        },
        {
          prop: 'insuranceExpiryDate',
          label: '保险到期日期',
          drillDown: true,
          tooltip: { tipValue: '点击查看保险详情' }
        },
        {
          prop: 'latestMaintainDate',
          label: '最近保养日期',
          drillDown: true,
          tooltip: { tipValue: '点击查看维修保养详情' }
        },
        {
          label: '操作',
          width: '280px',
          buttons: setTableButtons(['编辑', '删除', '设备参数'])
        }
      ]
    },
    addArray: true,
    formParams: {
      uid: '',
      carCode: '',
      carName: '',
      carModel: '',
      ownerName: (params) => ownerNameOf(params),
      ownerCardNum: (params) => ownerCardOf(params),
      ownerPhone: (params) => ownerPhoneOf(params),
      paramJson: null,
      vehicleLicense: [],
      fileLists: {
        vehicleLicense: []
      }
    },
    formRules: {
      carName: [
        {
          required: true,
          message: '设备名称不能为空',
          trigger: 'blur'
        }
      ],
      carCode: [
        {
          required: true,
          message: '设备编号不能为空',
          trigger: 'blur'
        }
      ],
      ownerName: [
        {
          required: true,
          message: '所有人不能为空',
          trigger: 'blur'
        }
      ]
    },
    formData: {
      card: '设备基本信息',
      bottomButtons: setFormButtons(['取消', '提交']),
      manualUpload: true,
      fields: [
        {
          key: 'carCode',
          label: '设备编号',
          type: 'input'
        },
        {
          key: 'carName',
          label: '设备名称',
          type: 'input'
        },
        {
          key: 'carModel',
          label: '设备型号',
          type: 'input'
        },
        {
          key: 'ownerName',
          label: '所有人',
          type: 'input',
          disabled: true
        },
        {
          key: 'ownerCardNum',
          label: '所有人证件号',
          type: 'input'
        },
        {
          key: 'ownerPhone',
          label: '所有人手机号码',
          type: 'input'
        },
        {
          key: 'vehicleLicense',
          label: '设备证件',
          type: 'upload',
          autoUpload: false,
          limit: 99
        }
      ]
    },
    hasPagination: true,
    insurance: {
      name: 'insurance',
      title: '设备保险备案',
      deleteFun: 'insurance/deleteInsurance',
      addFun: 'insurance/addInsurance',
      editFun: 'insurance/editInsurance',
      getListFun: 'officialCar/getOfficialCarInfo',
      getParentFun: 'officialCar/getCarsList',
      headButtons: setCheckButtons(['新增']),
      detailPage: [
        {
          buttonName: '新增',
          name: 'insurance',
          type: 'dialogForm'
        },
        {
          buttonName: '编辑',
          name: 'insurance',
          type: 'dialogForm',
          checkType: 'useRowData'
        },
        {
          buttonName: '保单图片',
          name: 'insurance',
          type: 'preview'
        }
      ],
      rowData: (params) => params.state.insurance.insuranceList,
      columns: [
        {
          label: '保单编号',
          prop: 'policyNumber',
          width: '200px'
        },
        {
          label: '投保人',
          prop: 'customer'
        },
        {
          label: '保险公司',
          prop: 'insuranceCompany',
          width: '200px',
          overflow: false
        },
        {
          label: '保险开始日期',
          prop: 'insuranceStartDate',
          type: 'date'
        },
        {
          label: '保险结束日期',
          prop: 'insuranceEndDate',
          type: 'date'
        },
        {
          label: '保险金额（万元）',
          prop: 'insuranceAmount',
          width: '100px'
        },
        {
          label: '保险费用（元）',
          prop: 'insurancePremium'
        },
        {
          label: '保单图片',
          prop: 'policyImageInfo',
          drillDown: true
        },
        {
          label: '备注',
          prop: 'mark',
          width: '300px'
        },
        {
          label: '操作',
          buttons: setTableButtons(['编辑', '删除'])
        }
      ],
      manualUpload: true,
      formParams: {
        insuredEntityUid: (params) => params.state.officialCar.carInfo.uid,
        insuredEntity: (params) =>
          params.state.officialCar.carInfo.carCode ||
          params.state.officialCar.carInfo.carName,
        customer: '',
        beneficiary: '',
        insuranceType: '财产险',
        insuranceCompany: '',
        policyNumber: '',
        insuranceStartDate: '',
        insuranceEndDate: '',
        insuranceAmount: '',
        insurancePremium: '',
        mark: '',
        policyImage: [],
        fileLists: {
          policyImage: []
        }
      },
      formRules: {
        policyNumber: [
          { required: true, message: '保单编号不能为空', trigger: 'blur' }
        ],
        insuranceCompany: [
          { required: true, message: '保险公司不能为空', trigger: 'change' }
        ]
      },
      formData: [
        { key: 'policyNumber', label: '保单编号', type: 'input' },
        { key: 'customer', label: '投保人', type: 'input' },
        { key: 'insuranceCompany', label: '保险公司', type: 'input' },
        { key: 'insuranceType', label: '保险类型', type: 'input' },
        {
          key: 'insuranceStartDate',
          label: '保险开始日期',
          type: 'time',
          format: 'yyyy-MM-dd'
        },
        {
          key: 'insuranceEndDate',
          label: '保险结束日期',
          type: 'time',
          format: 'yyyy-MM-dd'
        },
        {
          key: 'insuranceAmount',
          label: '保险金额',
          type: 'input',
          inputButton: '万元',
          number: 6
        },
        {
          key: 'insurancePremium',
          label: '保险费用',
          type: 'input',
          inputButton: '元',
          number: 2
        },
        { key: 'mark', label: '备注', type: 'input', span: 24 },
        {
          key: 'policyImage',
          label: '保单图片',
          type: 'upload',
          autoUpload: false,
          span: 24
        }
      ]
    },
    maintenance: {
      name: 'maintenance',
      title: '维修保养登记',
      deleteFun: 'maintenance/deleteMaintenance',
      addFun: 'maintenance/addMaintenance',
      editFun: 'maintenance/editMaintenance',
      getListFun: 'officialCar/getOfficialCarInfo',
      getParentFun: 'officialCar/getCarsList',
      headButtons: setCheckButtons(['新增']),
      detailPage: [
        {
          buttonName: '新增',
          name: 'maintenance',
          type: 'dialogForm'
        },
        {
          buttonName: '编辑',
          name: 'maintenance',
          type: 'dialogForm',
          checkType: 'useRowData'
        },
        {
          buttonName: '维修保养单据',
          name: 'maintenance',
          type: 'preview'
        }
      ],
      rowData: (params) => params.state.maintenance.maintainList,
      columns: [
        { label: '维修保养日期', prop: 'maintenanceDate' },
        { label: '维修保养人', prop: 'maintenancePerson' },
        {
          label: '维修保养类型',
          prop: 'maintenanceType',
          tag: [
            { label: '保养', type: 'success' },
            { label: '小修', type: 'warning' },
            { label: '大修', type: 'danger' },
            { label: '标定', type: 'info' },
            { label: '检验', type: '' }
          ]
        },
        { label: '下次保养日期', prop: 'nextMaintainDate' },
        { label: '维修保养费用(元)', prop: 'maintenanceCost' },
        { label: '维修保养内容', prop: 'maintenanceContent' },
        {
          label: '维修保养单据',
          prop: 'maintenanceDocumentInfo',
          drillDown: true
        },
        {
          label: '操作',
          buttons: setTableButtons(['编辑', '删除'])
        }
      ],
      manualUpload: true,
      formParams: {
        maintainEntityUid: (params) => params.state.officialCar.carInfo.uid,
        maintainEntity: (params) =>
          params.state.officialCar.carInfo.carCode ||
          params.state.officialCar.carInfo.carName,
        maintenancePerson: (params) => {
          return isTzInspectionOrg(params) ? TZ_INSPECTION_ORG_NAME : ''
        },
        maintenanceType: (params) => {
          return isTzInspectionOrg(params) ? '检验' : ''
        },
        maintenanceDate: daysFormat(new Date()),
        nextMaintainDate: '',
        maintenanceCost: '',
        maintenanceContent: '',
        maintenanceDocument: [],
        fileLists: {
          maintenanceDocument: []
        }
      },
      formRules: {
        maintenanceType: [
          { required: true, message: '维修保养类型不能为空', trigger: 'change' }
        ],
        maintenancePerson: [
          { required: true, message: '维修保养人不能为空', trigger: 'blur' }
        ],
        maintenanceDate: [
          { required: true, message: '维修保养日期不能为空', trigger: 'change' }
        ]
      },
      formData: [
        {
          key: 'maintenanceType',
          label: '维修保养类型',
          type: 'select',
          options: (params) => params.dictionarys.maintenanceType
        },
        { key: 'maintenancePerson', label: '维修保养人', type: 'input' },
        {
          key: 'maintenanceDate',
          label: '维修保养日期',
          type: 'time',
          format: 'yyyy-MM-dd'
        },
        {
          key: 'nextMaintainDate',
          label: '下次保养日期',
          type: 'time',
          format: 'yyyy-MM-dd'
        },
        {
          key: 'maintenanceCost',
          label: '维修保养费用',
          type: 'input',
          inputButton: '元',
          number: 2
        },
        {
          key: 'maintenanceContent',
          label: '维修保养内容',
          type: 'input',
          inputType: 'textarea',
          autosize: true,
          span: 24
        },
        {
          key: 'maintenanceDocument',
          label: '维修保养单据',
          type: 'upload',
          autoUpload: false,
          span: 24
        }
      ]
    },
    paramJson: {
      name: 'paramJson',
      title: '设备参数信息',
      editFun: 'officialCar/editOfficialCar',
      getParentFun: 'officialCar/getCarsList',
      formParams: {
        uid: '',
        paramJson: []
      },
      formRules: (params) => {
        var formRules = {}
        if (params.formValues && params.formValues.paramJson) {
          params.formValues.paramJson.forEach((item, index) => {
            formRules['key' + (index + 1)] = [
              {
                required: true,
                message: '请输入英文字母或数字组成的键名',
                trigger: 'blur'
              },
              {
                pattern: /\w/g,
                message: '请输入英文字母或数字',
                trigger: 'blur'
              }
            ]
            formRules['label' + (index + 1)] = [
              {
                required: true,
                message: '请输入设备参数名称',
                trigger: 'blur'
              }
            ]
            formRules['value' + (index + 1)] = [
              {
                required: true,
                message: '请输入设备参数值',
                trigger: 'blur'
              }
            ]
          })
        }
        return formRules
      },
      formData: (params) => {
        var formData = [
          {
            type: 'button',
            buttons: [
              { name: '添加设备参数', type: 'primary', icon: 'el-icon-plus' }
            ],
            span: 24
          }
        ]
        if (params.formValues && params.formValues.paramJson) {
          params.formValues.paramJson.forEach((item, index) => {
            const key = {
              key: 'key' + (index + 1),
              label: '参数' + (index + 1) + '键名',
              type: 'input',
              buttonIcon: 'el-icon-delete-solid',
              disabled: isFixedEquipmentParamKey(item.key),
              span: 12
            }
            const label = {
              key: 'label' + (index + 1),
              label: '参数' + (index + 1) + '名称',
              type: 'input',
              span: 12
            }
            const value = {
              key: 'value' + (index + 1),
              label: '参数' + (index + 1) + '值',
              type: 'input',
              span: 12
            }
            const unit = {
              key: 'unit' + (index + 1),
              label: '参数' + (index + 1) + '单位',
              type: 'input',
              span: 12
            }
            formData.splice(-1, 1, key, label, value, unit, {
              type: 'button',
              buttons: [
                { name: '添加设备参数', type: 'primary', icon: 'el-icon-plus' }
              ],
              span: 24
            })
          })
        }
        return formData
      }
    }
  }
}

export default ownEquipment
